import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './pages/login/login.component';
import { HomeComponent } from './pages/home/home.component';
import { ResponsiveComponent } from './pages/home/responsive/responsive.component'

import { LoginRecoverPasswdComponent } from './pages/login-recover-passwd/login-recover-passwd.component';
import { LoginRecoverPasswdCWComponent } from './pages/login-recover-passwd-cw/login-recover-passwd-cw.component';

import { LoginCubeWorksComponent } from './pages/login/login-cubeworks/login-cubeworks.component';
// import { RegisterCubeWorksUserComponent } from './pages/login/create-cubeworks-user/register-cubeworks-user.component';
import { AuthGuard } from './auth/auth-guard';



// import { EditProjectComponent } from './pages/sales-management/sales-project/edit-project/edit-project.component';
// import { DashboardCreateComponent } from './pages/dashboard/dashboard-create/dashboard-create.component'
// import { DashboardWidgetComponent } from './pages/dashboard/dashboard-widget/dashboard-widget.component'

const APP_ROUTES: Routes = [
  { path: '', component: LoginCubeWorksComponent },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginCubeWorksComponent },
  { path: 'logincubeworks', component: LoginCubeWorksComponent },
  // { path: 'createuserCW', component: RegisterCubeWorksUserComponent },
  { path: 'actPass', component: ResponsiveComponent },
  { path: 'RecoverPassword', component: LoginRecoverPasswdComponent },
  { path: 'RecoverPasswordCW', component: LoginRecoverPasswdCWComponent },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/home/home.module').then(m => m.HomeModule)
  },
  {
    path: 'home',
    canActivate: [AuthGuard],
    loadChildren: './pages/home/home.module#HomeModule'
  },

  //cube work
  {
    path: 'searchJobs',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/search-job/search-job.module#SearchJobModule'
  },
  {
    path: 'myFeed',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/my-feed/my-feed.module#MyFeedModule'
  },
  {
    path: 'myFeed2',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/myfeed2/myfeed2.module#Myfeed2Module'
  },
  {
    path: 'clientDashboard',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/client-dasboard/client-dasboard.module#ClientDasboardModule'
  },
  {
    path: 'jobPost',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/job-post/job-post.module#JobPostModule'
  },
  {
    path: 'contracts',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/contracts/contracts.module#ContractsModule'
  },
  {
    path: 'jobs',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/jobs/jobs.module#JobsModule'
  },
  {
    path: 'reviewPost',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/review-post/review-post.module#ReviewPostModule'
  },
  {
    path: 'reportsWork',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/reports-work-cube/reports-work-cube.module#ReportsWorkCubeModule'
  },
  {
    path: 'settings',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/settings-cube-work/settings-cube-work.module#SettingsCubeWorkModule'
  },
  {
    path: 'profileTalent',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/profile-talent/profile-talent.module#ProfileTalentModule'
  },
  {
    path: 'myProposals',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/my-proposals/my-proposals.module#MyProposalsModule'
  },
  {
    path: 'findWork',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/find-work/find-work.module#FindWorkModule'
  },
  {
    path: 'offerView',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/offer-view/offer-view.module#OfferViewModule'
  },
  {
    path: 'detailJob',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/detail-job/detail-job.module#DetailJobModule'
  },
  {
    path: 'myJobs',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/my-jobs/my-jobs.module#MyJobsModule'
  },
  {
    path: 'detailsJobs',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/my-jobs-details/my-jobs-details.module#MyJobsDetailsModule'
  },
  {
    path: 'chooseSettings',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/choose-settings/choose-settings.module#ChooseSettingsModule'
  },
  {
    path: 'submitProposal',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/submit-proposal/submit-proposal.module#SubmitProposalModule'
  },
  {
    path: 'viewProposal',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/view-proposals/view-proposals.module#ViewProposalsModule'
  },
  {
    path: 'viewJobPosting',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/view-job-posting/view-job-posting.module#ViewJobPostingModule'
  },
  {
    path: 'sendanOffer',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/send-offer/send-offer.module#SendOfferModule'
  },
  {
    path: 'message',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/cube-workmessage/cube-workmessage.module#CubeWorkmessageModule'
  },
  {
    path: 'dashboardTalents',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/dashboard-talents/dashboard-talents.module#DashboardTalentsModule'
  },
  {
    path: 'completedJobs',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/completed-jobs/completed-jobs.module#CompletedJobsModule'
  },
  {
    path: 'reviews',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/reviews/reviews.module#ReviewsModule'
  },
  {
    path: 'createuserCW',
    loadChildren: './pages/login/create-cubeworks-user/register-cubeworks-user.module#RegisterCubeWorksUserModule'
  },
  {
    path: 'paymentsCW',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/payments-cw/payments-cw.module#PaymentsCWModule'
  },

  {
    path: 'salesLeads',
    canActivate: [AuthGuard],
    loadChildren: 'src/app/pages/cubeWork/sales-leads/sales-lead.module#SalesLeadModule'
  },

  // {
  //   path: 'cubeMarket',
  //   loadChildren: 'src/app/pages/cubeWork/market/market.module#MarketModule'
  // },

  {
    path: 'cubeMarket',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/cubeWork/market/market-module').then(m => m.MarketModule)
  },

  {
    path: 'Estimates',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/estimation/estimation.module').then(m => m.EstimationModule)
  },

  {
    path: 'editEstimate',
    canActivate: [AuthGuard],
    loadChildren: './pages/estimation/edit-estimate/edit-estimate.module#EditEstimateModule'
  },

  {
    path: 'editRif',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/project-management/open-rif/edit-open-rif/edit-open-rif.module').then(m => m.EditOpenRifModule)
  },

  {
    path: 'videoTutorial',
    canActivate: [AuthGuard],
    loadChildren: () => import('./pages/videoTutorial/videoTutorial.module').then(m => m.videoTutorialModule)
  },

  { path: '**', redirectTo: '/logincubeworks' }

];

export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
